export enum EmployeeType {
  admin = 'admin',
  chain = 'chain',
  place = 'place',
  promoter = 'promoter',
  attendant = 'attendant',
  retailer = 'retailer',
};